import calendar from '../../../statics/img/icons/calendar.svg'
import page from '../../../statics/img/icons/page.svg'
import clip from '../../../statics/img/icons/clip.svg'
import pencil from '../../../statics/img/icons/pencil.svg'
import Shield from '../../../statics/img/icons/Shield.svg'
import { useModal } from '../../../customHooks/useModal'
import Modal from '../../../components/modal'
import SetConditions from '../../../components/setConditions'
import { useEffect, useState } from 'react';
import Calendar from './calendar'
import NumebrSelect from '../../../components/numberSelect'
import { useAppDispatch, useAppSelector } from '../../../store/hooks'
import { changeNumbersOfWinners } from '../../../store/sweepstakes'
import { createRaffle, getWinner } from '../../../store/raffle'

export default function GetAWinner({ setTab, create = false }: any) {
  const dispatch = useAppDispatch()
  const { raffleInfo, status } = useAppSelector((state) => state.raffle)
  const { isShown, toggle } = useModal()
  const [startDate, setStartDate] = useState(raffleInfo ? new Date(raffleInfo.start_date) : new Date())
  const [endDate, setEndDate] = useState(raffleInfo ? new Date(raffleInfo.end_date) : new Date())
  const { numberOfWinners } = useAppSelector((state) => state.sweepstakes)
  const [conditions, setConditions]: any = useState({})

  const formatDate = (date: any) => {
    const actualDate = `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`
    return actualDate
  }
  useEffect(() => {
    if (raffleInfo && raffleInfo.conditions[0].repeat) {
      setConditions({ condition1: true })
    }
  }, [])


  const sendRaffleInfo = () => {
    const raffleToSend = {
      leads_total: 1,
      leads_valid: 5,
      start_date: startDate.toISOString().replace(/[TZ]/g, ' ').trim(),
      end_date: endDate.toISOString().replace(/[TZ]/g, ' ').trim(),
      winners_no: true,
      conditions: [
        {
          two_winners: false,
          repeat: (conditions?.condition1) || false
        }
      ]
    }
    dispatch(createRaffle(raffleToSend)).then(res => {
      setTab((prev: any) => prev + 1)
    })
    console.log(raffleToSend)
  }

  const getWinnerFunction = () => {
    const winner = {
      start_date: startDate.toISOString().slice(0,-14),
      end_date: endDate.toISOString().slice(0,-14),
      repeat_winners: 0
    }



    dispatch(getWinner(winner)).then(res => {
      setTab((prev: any) => prev + 1)
    })
  }

  return (<>
    <Modal isActive={isShown} clouse={toggle}>
      <SetConditions toggle={toggle} setConditions={setConditions} />
    </Modal>
    <div className="c-winner-management-info">
      <div className="c-winner-management-info-name">
        <h1>Event Name: Gas Car Raffle</h1>
      </div>
      <div className="c-winner-management-info-values">
        {/* <div className="c-winner-management-info-values-item">
          <div className="left">
            <img src={Shield} alt="" />
            <p>Total Entries</p>
          </div>
          <div className="right">
            99,000
          </div>
        </div>
        <div className="c-winner-management-info-values-item">
          <div className="left">
            <img src={page} alt="" />
            <p>Valid Entries</p>
          </div>
          <div className="right">
            99,000
          </div>
        </div> */}
        <div className="c-winner-management-info-values-item">
          <div className="left">
            <img src={calendar} alt="" />
            <p>Start Date</p>
            {
              (create) && <Calendar setDate={setStartDate} />
            }
          </div>
          <div className="right">
            {
              (create) && <img src={pencil} alt="" />
            }
            <p>{formatDate(startDate)}</p>
          </div>
        </div>
        <div className="c-winner-management-info-values-item">
          <div className="left">
            <img src={calendar} alt="" />
            <p>End Date</p>
            {
              (create) && <Calendar setDate={setEndDate} />
            }
          </div>
          <div className="right">
            {
              (create) && <img src={pencil} alt="" />
            }
            <p>{formatDate(endDate)}</p>
          </div>
        </div>
        <div className="c-winner-management-info-values-item conditions" onClick={(create) ? toggle : () => { }}>
          <div className="up">
            <div className="left">
              <img src={clip} alt="" />
              <p>Conditions</p>
            </div>
            <div className="right">
              {
                (create) && <img src={pencil} alt="" />
              }
            </div>
          </div>
          <div className="down">
            <ul className="content">
              {(conditions?.condition1) && <li>No Repeat Winners</li>}
              {(conditions?.condition2) && <li>No repear</li>}
              {(conditions?.condition3) && <li>No repear</li>}
              {(conditions?.condition4) && <li>No repear</li>}
              {(conditions?.condition5) && <li>Only California</li>}
              {(conditions?.condition6) && <li>No repear</li>}
            </ul>
          </div>
        </div>
        <div className="c-winner-management-info-values-item">
          <div className="left">
            <img src={calendar} alt="" />
            <p>Nro Winners</p>
          </div>
          <div className="right">
            {
              (create) ? <>
                <img src={pencil} alt="" />
                <NumebrSelect setValue={(a: any) => dispatch(changeNumbersOfWinners(a))} defaultValue={numberOfWinners} />
              </>
                : <p>{numberOfWinners}</p>
            }
          </div>
        </div>
      </div>
    </div>
    {
      (raffleInfo.status !== 3) &&
      <div className="c-winner-management-footer">
        {
          (create)
            ? <>
              {
                (status === 'createRaffle_pending')
                  ? <button className='buttonwinner buttonOrangeWinner'>Loading...</button>
                  : <button onClick={sendRaffleInfo} className='buttonwinner buttonOrangeWinner'>Create Raffle</button>
              }

            </>
            : <button onClick={getWinnerFunction} className='buttonwinner buttonOrangeWinner'>Get a Winner</button>
        }
      </div>
    }
  </>)
}